/**
 * Boilermaker Race Results - Main JavaScript Entry Point
 * Modern jQuery 3.7.x implementation
 */

import $ from 'jquery';

// Make jQuery available globally for compatibility
window.$ = window.jQuery = $;

// Import modules
import ThemeSwitcher from './theme-switcher.js';
import { reportWebVitals } from './web-vitals.js';

$(document).ready(function() {
  
  // ===== Initialize Theme Switcher =====
  new ThemeSwitcher();
  
  // ===== Table Striping =====
  $("table tr:even").addClass("striped");
  $("table tr.striped.genderM").addClass("striped-m");
  $("table tr.striped.genderF").addClass("striped-f");
  
  // ===== Loading Cursor for Forms =====
  $("form.search").on('submit', function() {
    $("body").addClass("loading");
  });
  
  // ===== Loading Cursor for Pagination =====
  $(".paging a").on('click', function() {
    $("body").addClass("loading");
  });
  
  // ===== Global AJAX Loading Indicator =====
  $(document).ajaxStart(function() {
    $("body").addClass("loading");
  }).ajaxStop(function() {
    $("body").removeClass("loading");
  });
  
  // ===== Skip to Content Link =====
  const skipLink = $('<a>')
    .attr('href', '#main-content')
    .addClass('skip-to-content')
    .text('Skip to main content')
    .prependTo('body');
  
  skipLink.on('click', function(e) {
    e.preventDefault();
    $('#main-content').attr('tabindex', '-1').focus();
  });
  
  // ===== Focus Visible Polyfill for older browsers =====
  // Modern browsers support :focus-visible natively
  $(document).on('mousedown', function() {
    $('body').addClass('using-mouse');
  });
  
  $(document).on('keydown', function() {
    $('body').removeClass('using-mouse');
  });
  
  // ===== Shrinking Header on Scroll =====
  const headerEl = document.querySelector('header');
  if (headerEl) {
    window.addEventListener('scroll', function() {
      headerEl.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  console.log('✅ Boilermaker Race Results initialized');
});

// ===== Performance Monitoring =====
reportWebVitals(console.log);
